import DA from '@agora/data-analysis'
const dataLayer = window['dataLayer'] || []

const gtag = function (..._args: any) {
  // eslint-disable-next-line prefer-rest-params
  dataLayer.push(arguments)
}

const dtag = (label: any, options?: any) => {
  DA.event({
    event: label,
    category: options.event_category,
    event_label: options.event_label,
    event_value: options.event_value,
    target: options.target,
    payload: options.payload,
    action: options.action,
  })
}

export const ga = (name: 'event' | 'config' | 'get' | 'set', label: any, options?: any) => {
  const hostname = document.location.hostname
  switch (hostname) {
    case 'pm.agoralab.co':
      gtag(name, label, options)
      dtag(label, options)
      break
    case 'pm-staging.agoralab.co':
      gtag(name, label, Object.assign({}, options, { traffic_type: 'internal' }))
      dtag(label, { ...options, debug: true })
      break
    default:
      gtag(name, label, Object.assign({}, options, { debug_mode: true }))
      dtag(label, { ...options, debug: true })
  }
}

export const traceEvent = {
  // 访问导航页
  navigation: {
    event_categories: {
      ef_pmo: 'ef_pmo',
    },
    action: 'show',
    events: {
      show_navigation: 'show_navigation',
    },
    event_labels: {
      home: 'home',
      projects: 'projects',
      portfolios: 'portfolios',
      teams: 'teams',
      okrProject: 'okr/project',
      customers: 'customers',
      productions: 'productions',
      devlops: 'devlops',
    },
  },

  // 个人页面点击
  personalPage: {
    event_categories: {
      ef_pmo_home_my_project_stages: 'ef_pmo_home_my_project_stages',
      ef_pmo_home_my_projects_owner: 'ef_pmo_home_my_projects_owner',
      ef_pmo_home_my_projects_member: 'ef_pmo_home_my_projects_member',
      ef_pmo_home_my_portfolios: 'ef_pmo_home_my_portfolios',
      ef_pmo_home_my_portfolios_owner: 'ef_pmo_home_my_portfolios_owner',
      ef_pmo_home_my_portfolios_member: 'ef_pmo_home_my_portfolios_member',
      ef_pmo_home_my_favorites_projects: 'ef_pmo_home_my_favorites_projects',
      ef_pmo_home_my_favorites_portfolios: 'ef_pmo_home_my_favorites_portfolios',
      ef_pmo_home_my_favorites_teams: 'ef_pmo_home_my_favorites_teams',
      ef_pmo_home_my_customers_owner: 'ef_pmo_home_my_customers_owner',
      ef_pmo_home_my_customers_member: 'ef_pmo_home_my_customers_member',
      ef_pmo_home_my_favorites_customers: 'ef_pmo_home_my_favorites_customers',
    },
    action: 'click',
    events: {
      click_check_detail: 'click_check_detail',
    },
    targets: {
      ef_pmo_project_detail: 'ef_pmo_project_detail',
      ef_pmo_portfolio_detail: 'ef_pmo_portfolio_detail',
      ef_pmo_teams: 'ef_pmo_teams',
      ef_pmo_customer_detail: 'ef_pmo_customer_detail',
    },
  },

  // 项目 tab 点击
  projectTab: {
    event_categories: {
      ef_pmo_project_detail: 'ef_pmo_project_detail',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      overview: 'overview',
      stages_and_tasks: 'stages_and_tasks',
      weekly_reports: 'weekly_reports',
      files: 'files',
      evaluation: 'evaluation',
      issue_list: 'issue_list',
      resource: 'resource',
    },
  },

  // 组合 tab 点击
  portfolioTab: {
    event_categories: {
      ef_pmo_portfolio_detail: 'ef_pmo_portfolio_detail',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      overview: 'overview',
      weekly_reports: 'weekly_reports',
      files: 'files',
    },
  },

  // 团队 tab 点击
  teamTab: {
    event_categories: {
      ef_pmo_teams: 'ef_pmo_teams',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      objectives: 'objectives',
      projects_portfolios: 'projects_portfolios',
      weekly_reports: 'weekly_reports',
      resource: 'resource',
    },
  },

  // 项目资源管理页面点击
  projectResource: {
    event_categories: {
      ef_pmo_project_detail_resource: 'ef_pmo_project_detail_resource',
    },
    action: 'click',
    events: {
      click_ef_pmo_project_detail_resource: 'click_ef_pmo_project_detail_resource',
    },
    targets: {
      display_phase: 'display_phase',
      view: 'view',
      unfold_stages: 'unfold stages',
      fold_stages: 'fold stages',
    },
  },

  // 团队资源管理页面点击
  teamResource: {
    event_categories: {
      ef_pmo_teams_resource: 'ef_pmo_teams_resource',
    },
    action: 'click',
    events: {
      click_ef_pmo_teams_resource: 'click_ef_pmo_teams_resource',
    },
    targets: {
      display_phase: 'display_phase',
      view: 'view',
      unfold_stages: 'unfold stages',
      fold_stages: 'fold stages',
    },
  },

  // 详情页访问时长
  detailPage: {
    event_categories: {
      ef_pmo_home: 'ef_pmo_home',
      ef_pmo_project: 'ef_pmo_project',
      ef_pmo_portfolios: 'ef_pmo_portfolios',
      ef_pmo_portfolios_detail: 'ef_pmo_portfolios_detail',
      ef_pmo_teams: 'ef_pmo_teams',
      ef_pmo_customers: 'ef_pmo_customers',
      ef_pmo_productions: 'ef_pmo_productions',
      ef_pmo_devlops: 'ef_pmo_devlops',
    },
    action: 'expose_time',
    events: {
      expose_time_project_detail: 'expose_time_project_detail',
      expose_time_portfolio_detail: 'expose_time_portfolio_detail',
      expose_time_teams: 'expose_time_teams',
      expose_time_customer_detail: 'expose_time_customer_detail',
      expose_time_production_detail: 'expose_time_production_detail',
      expose_time_devlop_detail: 'expose_time_devlop_detail',
    },
    targets: {
      ef_pmo_project_detail: 'ef_pmo_project_detail',
      ef_pmo_portfolios_detail: 'ef_pmo_portfolios_detail',
      ef_pmo_teams: 'ef_pmo_teams',
      ef_pmo_customer_detail: 'ef_pmo_customer_detail',
      ef_pmo_production_detail: 'ef_pmo_production_detail',
      ef_pmo_devlop_detail: 'ef_pmo_devlop_detail',
    },
  },

  // customer 相关埋点
  customerDetail: {
    event_categories: {
      ef_pmo_customers_detail: 'ef_pmo_customers_detail',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      detail: 'overview',
      weekly_reports: 'weekly_reports',
    },
  },

  // production 相关埋点
  productionDetail: {
    event_categories: {
      ef_pmo_productions_detail: 'ef_pmo_productions_detail',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      detail: 'overview',
      weekly_reports: 'weekly_reports',
    },
  },

  devlopDetail: {
    event_categories: {
      ef_pmo_devlops_detail: 'ef_pmo_devlops_detail',
    },
    action: 'click',
    events: {
      click_switch_tab: 'click_switch_tab',
    },
    targets: {
      detail: 'overview',
      weekly_reports: 'weekly_reports',
    },
  },

  // 链路点击
  fullPathClick: {
    event_categories: {
      ef_pmo_project_detail: 'ef_pmo_project_detail',
    },
    action: 'click',
    events: {
      click_progress_bar: 'click_progress_bar',
    },
  },
}
